import { makeStyles } from '@material-ui/core';

const useInUsaStyles = makeStyles((theme) => {
  const mobileBreakpoint = theme.breakpoints.down('sm');
  return ({
    inUsaWrapper: {
      minHeight: 'calc(100vh - 207px)',
      marginBottom: 0
    },
    wrapper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    continueBtn: {
      width: '150px',
      height: '30px',
      background: '#007DB8 !important',
      borderRadius: '4px',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '22px',
      fontFamily: 'var(--font-family-bold)',
      textTransform: 'capitalize',
      color: 'var(--white) !important',
      marginTop: '-0.5rem',
      left: '430px',
      '&.Mui-disabled': {
        backgroundColor: 'var(--neutrals-grey-300, #E0E0E0) !important',
        color: 'var(--neutrals-grey-600, #757575) !important',
        boxShadow: 'none',
        borderRadius: '4px',
        textAlign: 'center',
      },
      [mobileBreakpoint]: {
        width: '100%',
        left: '0px'
      },
    },
    inputBox: {
      width: '576px',
      border:'1px solid #9E9E9E',
      padding:'0 15px',
      paddingLeft: '16px',
      [mobileBreakpoint]: {
        width: '100%'
      },
    },
    radio: {
      width: '576px',
      marginBottom: '40px',
      border: ' 1px solid #E0E0E0',
      borderRadius: '4px',
      [mobileBreakpoint]: {
        width: 'auto'
      },
    },
    title: {
      [mobileBreakpoint]: {
        width: '100% !important',
        margin: '0px !important'
      },
    },
    mobileWidth: {
      [mobileBreakpoint]: {
        width: '100% !important',
        fontSize: '16px !important'
      },
    },
    root: {
      [mobileBreakpoint]: {
        backgroundImage: 'none !important'
      },
    },
    trapezoidBgInUsa: {
      position: 'relative',
      zIndex: 1,
      "&::before": {
        content: '""',
        background: 'linear-gradient(234deg, #005C82 28.58%, #0B9EDB 99.46%)',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        clipPath: 'polygon(95% 0, 100% 0, 100% 100%, 37.5% 100%)',
        backgroundSize: 'cover'
      }
    },
  });
});

export default useInUsaStyles;
